<template>
  <ul :class="{'c-parts-last-learning__stars':true, '-get':fullScreen, '-graph': isGraph}">
    <li v-for="star_num of stars" :key="star_num" :ref="(el) => {starNumRef[star_num] = el}" :class="{'default': defaultStar(star_num)}"></li>
  </ul>
</template>

<script setup lang="ts">
  import {ref, onUnmounted, watch} from "vue";

  const stars = ref(3)
  const refresh_timer = ref([])
  const starNumRef = ref([])
  const props = withDefaults(
    defineProps<{
      numberOfStars?: number;
      activeStars?: boolean;
      fullScreen?: boolean;
      isGraph?: boolean;
    }>(),
    {
      numberOfStars: 0,
      activeStars: false,
      fullScreen: false,
      isGraph: false,
    }
  );

  function defaultStar(num) {
    if (!props.activeStars) {
      if (props.numberOfStars >= num) {
        return true
      }
    }
  }

  async function animate(num){
    return new Promise((resolve, reject) => {
      for (let i = 1; i <= stars.value; i++) {
        let order = i + 1;
        let delay = order * 200;
        let timer = setTimeout(() => {
          if (num >= i) {
            starNumRef.value[i].classList.add("active")
          } else {
            starNumRef.value[i].classList.remove("active")
          }
        }, delay)
        refresh_timer.value.push(timer)
      }
    })
  }
  watch(
    () => props.activeStars,
    (newVal) => {
      // NFR-4649 親コンポーネント側で子コンポーネントのメソッドは直接に呼ばずにフラグで呼んで実行する。
      if(newVal){
        animate(props.numberOfStars)
      }
    }
  )
  onUnmounted(() => {
    for(let i in refresh_timer.value){
      clearTimeout(refresh_timer.value[i])
    }
  })
  defineExpose({
    animate,
  })
</script>
